module.exports = (__webpack_require__(0))(391)


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/core-js/modules/es6.number.min-safe-integer.js from dll-reference polyfills_lib
// module id = 332
// module chunks = 2